import { t } from 'i18next';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Checkbox,
  ButtonGroup,
  Button,
  OverlayTrigger,
  Popover,
  Glyphicon,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class ShipmentStatusFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actives: this.props.actives,
    };
  }

  onChange(value, ev) {
    const state = Object.assign({}, this.state);
    if (ev.target.checked) {
      state.actives.push(value);
    } else {
      const idx = state.actives.indexOf(value);
      state.actives.splice(idx, 1);
    }

    this.setState(state);
    this.props.onChange(state.actives);
  }

  onFilterStatus(value) {
    function getKey(status) {
      return status.slug;
    }

    function isJobActive(status) {
      const nonActiveStatuses = ['job_closed', 'job_canceled'];
      return nonActiveStatuses.indexOf(status.slug) === -1;
    }

    const state = Object.assign({}, this.state);
    if (value === 'active') {
      state.actives = this.props.items.filter(isJobActive).map(getKey);
    } else if (value === 'non_active') {
      state.actives = this.props.items
        .filter((status) => !isJobActive(status))
        .map(getKey);
    } else {
      state.actives = [];
    }

    this.setState(state);
    this.props.onChange(state.actives);
  }

  renderPopup() {
    const { t } = this.props;
    return (
      <Popover id="shipment-status-popup" className="filter-dropdown-wrapper">
        <ButtonGroup className="status-button-group">
          <Button
            active={this.state.actives === 'clear'}
            onClick={() => this.onFilterStatus('clear')}
            bsSize="small"
          >
            {titleize(t('CLEAR'))}
          </Button>
          <Button
            active={this.state.actives === 'active'}
            onClick={() => this.onFilterStatus('active')}
            bsSize="small"
          >
            {titleize(t('ACTIVE'))}
          </Button>
          <Button
            active={this.state.actives === 'non_active'}
            onClick={() => this.onFilterStatus('non_active')}
            bsSize="small"
          >
            {t('NON_ACTIVE')}
          </Button>
        </ButtonGroup>

        <hr />
        <ul>
          {this.props.items.map((shipmentStatus) => (
            <li key={shipmentStatus.slug}>
              <Checkbox
                checked={this.props.actives.indexOf(shipmentStatus.slug) > -1}
                onChange={(e) => this.onChange(shipmentStatus.slug, e)}
              >
                {titleize(t(shipmentStatus.localizationSlug))}
              </Checkbox>
            </li>
          ))}
        </ul>
      </Popover>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className={this.props.className}>
        <OverlayTrigger
          className={this.props.className}
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderPopup()}
        >
          <div>
            <Button
              className={this.props.buttonClassName}
              bsStyle="default"
              style={{ outline: 'none' }}
              bsSize="small"
            >
              {t('SHIPMENT_STATUS')}
              <Glyphicon
                glyph="chevron-down"
                className={`button-down-glyph ${this.props.iconColor}`}
              />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

ShipmentStatusFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  actives: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  iconColor: PropTypes.string,
};

ShipmentStatusFilter.defaultProps = {
  buttonClassName: '',
  iconColor: '',
};

export default withTranslation()(ShipmentStatusFilter);
